<template>
  <div class="sample-list">
    <div class="sample-item" v-for="(item, index) in sampleList" :key="index">
      <el-form label-position="right" label-width="168px" :model="item" :rules="sampleRules" :ref="'sample' + index">
        <div class="sample-title" v-if="commonProps.isOiq"><span>{{item.row}}#</span> {{item.sampleName}}</div>
        <div class="ind-sample-title" v-else>{{index + 1}}#</div>
        <el-row :gutter="47">
          <el-col :span="12" v-for="item2 in item.sampleFromDTOList" :key="item2.sampleKey">
            <el-form-item :label="item2.sampleKeyName" :prop="item2.sampleKey" :rules="getRules(item2, item)" v-if="getShow(item2)" :class="{'is-required': item2.isMust}">
              <el-input placeholder="" v-model="item[item2.sampleKey]" :disabled="applicationDiabled || disabledAll" maxlength="400"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="btns" v-if="!disabledAll && !commonProps.isOiq">
        <el-button type="text" class="add-sample" @click="addSample(index, item)" v-if="sampleList.length < 50"><img src="../../assets/images/apply/add.png" alt="">复制样品</el-button>
        <el-button type="text" class="del-sample" v-if="sampleList.length!==1" @click="delSample(index)"><img src="../../assets/images/apply/del.png" alt="">删除样品</el-button>
      </div>
    </div>
    <el-button class="common-btn" @click="addSample(sampleList.length-1, basicSample)" v-if="sampleList.length < 50 && !disabledAll && !commonProps.isOiq && commonProps.form.orderBase.businessCode">+添加样品信息</el-button>
  </div>
</template>

<script>
import expandIcon from '../../assets/images/spec-expand.png'
import closeIcon from '../../assets/images/spec-close.png'
export default {
  name: 'TicSample',
  props: {
    required: {
      type: Object,
      default() {
        return {}
      }
    },
    requiredEn: {
      type: Object,
      default() {
        return {}
      }
    },
    basicSample: {
      type: Object,
      default() {
        return {}
      }
    },
    commonProps: {
      type: Object,
      default() {
        return {}
      }
    },
    applicationDiabled: {
      type: Boolean,
      default: false
    },
    disabledAll: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default() {
        return []
      }
    },
    reportLuaCode: {
      type: String,
      default: 'ZN'
    },
  },
  data() {
    return {
      sampleList: [],
      sampleRules: {
        sampleNameCn:[this.required],
        sampleNameEn:[this.requiredEn]
      },
      expandIcon,
      closeIcon
    }
  },
  watch: {
    list: {
      handler(val) {
        // this.sampleList = JSON.parse(JSON.stringify(val))
        this.sampleList = val
        // this.$emit('updateSampleList', this.sampleList)
      },
      immediate: true
    }
  },
  methods: {
    getShow(data) {
      return data.lua === 'CHI' && this.reportLuaCode !== 'EN' || data.lua === 'EN' && this.reportLuaCode !== 'ZN'
    },
    getRules(data, item) {
      if (data.isMust) {
        return [this.required]
      }
      if (this.reportLuaCode !== 'ZN' && this.reportLuaCode !== 'EN') {
        const validate = (rule, value, callback) => {
          if (this.commonProps.isSave && !value && item.sampleFromGoup[data.sampleGroup].some(v => v !== data.sampleKey && item[v])) {
            return callback(new Error('必填项'));
          } else {
            return callback()
          }
        }
        return [{ validator: validate }]
      }
      return []
    },
    addSample(index, copySample) {
      let sample = JSON.parse(JSON.stringify(copySample))
      sample.sampleNo = new Date().getTime() + String.fromCharCode(65 + Math.floor(Math.random() * 26))
      this.sampleList.splice(index+1, 0, sample)
    },
    delSample(index) {
      const delSample = this.sampleList[index]
      this.$emit('delSample', delSample)
      this.sampleList.splice(index, 1)
    },
    changeSpecExpand(data) {
      this.$set(data, 'isExpand', !data.isExpand)
    },
    validateForm(key, isArr) {
      if (isArr) {
        return new Promise(resolve => this.$refs[key][0].validate(resolve))
      }
      return new Promise(resolve => this.$refs[key].validate(resolve))
    },
    getValidate() {
      const arr = []
      this.sampleList && this.sampleList.forEach((v, index) => {
        const key = 'sample' + index
        arr.push(this.validateForm(key, true))
      })
      return arr
    },
    getSample() {
      return JSON.parse(JSON.stringify(this.sampleList))
    }
  }
};
</script>

<style scoped lang="scss">
.sample-list {
  position: relative;
  .btns {
    position: absolute;
    top: 15px;
    right: 28px;
    .el-button {
      display: block;
      margin-left: 0;
    }
  }
}
  .sample-item {
    background: #F5F5F5;
    margin-bottom: 16px;
    padding: 15px 148px 6px 0;
    position: relative;
    .ind-sample-title {
      color: rgb(255, 102, 0);
      font-size: 14px;
      font-weight: 700;
      line-height: 14px;
      position: absolute;
      top: 28px;
      left: 25px;
    }
    .sample-title {
      font-size: 14px;
      line-height: 14px;
      color: #333333;
      padding: 4px 25px 15px;
      span {
        color: #FF6600;
      }
    }
    .add-sample, .del-sample {
      font-size: 14px;
      color: #CA4300;
      padding: 10.5px 0;
      img {
        vertical-align: text-top;
        margin-right: 10px;
      }
    }
    .del-sample {
      color: #878787;
      margin-top: 15px;
      img {
        margin-right: 12px;
      }
    }
  }
</style>
<style lang="scss">
.create-form .sample-list {
  .common-btn {
    background: rgba(255, 102, 0, 0.05);
    width: 142px;
  }
  .el-form-item {
    margin-bottom: 15px;
  }
}
</style>
